const release2021 = [
  {
    date: '2021-11-11',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문분할 API <code>type</code> 파라미터 추가
        </>,
        apis: [
          {
            method: 'PUT',
            action: '/order/divide',
          }
        ]
      }
    ]
  },
  {
    date: '2021-11-10',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 상세 조회 API 결과 변수명 클레임메세지: <code>claim_msg</code> {'=>'} <code>ord_status_msg</code> 수정
        </>,
        apis: [
          {
            method: 'GET',
            action: '/order/:uniq',
          }
        ]
      }
    ]
  },
  {
    date: '2021-11-08',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          SKU상품 수정 API 판매가<code>product_price</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/stock/edit',
          }
        ]
      }
    ]
  },
  {
    date: '2021-11-05',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          SKU상품 등록 API 원산지, 품목정보고시 <code>필수</code> {'=>'} <code>비필수</code> 로 수정
        </>,
        apis: [
          {
            method: 'POST',
            action: '/stock/add'
          }
        ]
      }
    ]
  },
  {
    date: '2021-09-14',
    items: [
      {
        type: 'Added',
        summary:
        <>
          작업등록 API 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/work/addWork',
          }
        ]
      }
    ]
  },
  {
    date: '2021-09-09',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          선택작업 등록 API 지원 작업 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/work/addWorkSelect',
            detail:
            <>
              - <code>온라인상품 판매중지 전송</code>(CANCEL_PROD)<br />
              - <code>온라인상품 판매기간 연장</code>(EXTENT_PROD)
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2021-07-21',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          선택작업 등록 API 온라인상품 동기화 작업<code>SYNC_PROD_STATE</code>추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/work/addWorkSelect',
          }
        ]
      }
    ]
  },
  {
    date: '2021-07-01',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          온라인상품 등록 API 파라미터 원산지 비필수 여부 변경
        </>,
        apis: [
          {
            method: 'POST',
            action: '/products/add',
            detail:
            <>
              온라인상품 등록 시 원산지 <code>[비필수]</code> {'=>'} <code>[필수]</code> 로 수정
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2021-06-25',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          온라인상품 상세 조회 API Response 변수명 변경
        </>,
        apis: [
          {
            method: 'GET',
            action: '/products/:ol_shop_no',
            detail:
            <>
              - 옵션수량: <code>cnt_limit</code> {'=>'} <code>stock_cnt</code><br />
              - 판매가능재고: <code>stock_cnt</code> {'=>'} <code>stock_cnt_enable</code>
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2021-06-24',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          작업결과 조회 API Response 결과 메세지 추가
        </>,
        apis: [
          {
            method: 'GET',
            action: '/work/:work_no',
          }
        ]
      }
    ]
  },
  {
    date: '2021-06-15',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          온라인상품 등록 API 파라미터 기본값 변경 및 온라인상품 수정 API 문서 수정
        </>,
        apis: [
          {
            method: 'POST',
            action: '/products/add',
            detail: 
            <>
              미성년자 구매여부(minor_yn) 기본값 <code>true</code> 로 변경 (미성년자 구매가능)<br />
            </>
          },
          {
            method: 'PUT',
            action: '/products/edit',
            detail:
            <>
            온라인상품 수정 결과상태 문서 수정 <code>status</code> {'=>'} <code>result</code>
            </>
          }
        ]
      }   
    ]
  },
  {
    date: '2021-06-04',
    items: [
      {
        type: 'Added',
        summary:
        <>
          온라인상품 상세조회 API 추가
        </>,
        apis: [
          {
            method: 'GET',
            action: '/products/:ol_shop_no',
          }
        ]
      }
    ]
  },
  {
    date: '2021-06-02',
    items: [
      {
        type: 'Added',
        summary:
        <>
          SKU상품 상세조회 API 추가
        </>,
        apis: [
          {
            method: 'GET',
            action: '/stock/:sku_cd',
          }
        ]
      }
    ]
  }
]

export default release2021;